module.exports = __webpack_public_path__ + "media/images/dividend/il-coupontheme-independence-right-e9a0dfc5cb6f2edf85d968014587fc57.svg";